import { useEffect } from 'react';

/**
 * Asks the browser to confirm before the page is reloaded or closed while the component is mounted
 */
const useWarnBeforeUnload = (): void => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};

export default useWarnBeforeUnload;
